export default __webpack_public_path__ + "static/media/demo4.f13b868e.jpg";